import { cn } from "@/lib/utils";

export default function KpiCard({ label, value, icon: Icon, hint, testId, tone = "default" }) {
  const toneClasses = {
    default: "text-primary bg-primary/10",
    success: "text-emerald-400 bg-emerald-400/10",
    warning: "text-amber-400 bg-amber-400/10",
    muted: "text-muted-foreground bg-white/[0.04]",
  };
  return (
    <div
      data-testid={testId}
      className="card-surface p-5 flex flex-col justify-between min-h-[130px] hover:border-white/10 transition-colors"
    >
      <div className="flex items-start justify-between">
        <span className="label-eyebrow">{label}</span>
        {Icon ? (
          <div className={cn("w-9 h-9 rounded-lg grid place-items-center", toneClasses[tone])}>
            <Icon className="w-4 h-4" />
          </div>
        ) : null}
      </div>
      <div className="mt-4">
        <div className="text-3xl font-heading font-bold tracking-tight">{value}</div>
        {hint ? <div className="text-xs text-muted-foreground mt-1">{hint}</div> : null}
      </div>
    </div>
  );
}
